import useFlags from 'launchdarkly-react-client-sdk/lib/useFlags';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import NavbarContent from './NavbarContent';
import { mayaAdminDashboardRoute } from 'basics/constants/routes.constants';
import { useGetConfig } from 'basics/utils/getConfig.hook';
import { mayaLogoStyle } from 'components/Layout/NavBar/Navbar.styles';
import MayaMenu from 'components/MayaMenu';
import { useCurrentUserState } from 'contexts/user';
import AppBar from 'yoda-ui/components/AppBar';
import Box from 'yoda-ui/components/Box';
import Toolbar from 'yoda-ui/components/Toolbar';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

const NavBar: FC = () => {
  const flags = useFlags();
  const navigate = useNavigate();
  const { user } = useCurrentUserState();
  const currentModuleConfig = useGetConfig();
  const location = useLocation();
  const currentURL = location.pathname;

  if (currentModuleConfig.noLayoutURL.includes(currentURL)) {
    return null;
  }

  return (
    <AppBar position="fixed">
      <Box paddingX={ YodaSpacing.none }>
        <Toolbar>
          <Box display="flex" flex="column" justifyContent="space-between" width="100%">
            <Box sx={ mayaLogoStyle } onClick={ () => navigate(mayaAdminDashboardRoute) }>
              <img src={ currentModuleConfig?.logo } alt="biogen-logo" style={ { height: 'inherit' } } />
            </Box>
            { user && !flags.mayaBdcfcsd1532EnableMaintenancePage?.enabled ? <MayaMenu /> : null }
            <Box display="flex" alignItems="flex-start">
              { flags.mayaBdcfcsd1532EnableMaintenancePage?.enabled ? null : <NavbarContent /> }
            </Box>
          </Box>
        </Toolbar>
      </Box>
    </AppBar>
  );
};

export default NavBar;
